import React, { useContext, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import * as urlService from "../../view/urlService";
import { debug } from "../../utils";
import { TableContext, PopupContext } from "../../index";
import { showSuccessToast } from "../../validation/ToastContainer";
// import ValidationResultTableSearchSection from "../ValidationResultTableSearchSection";
import { RemediationModal } from "../RemediationModal";
import {
    acknowledgeValidationResult, removeRulesFromWhitelist,
    exportValidationData, getLastValidationDateTime
} from "../ruleService";
import { POPUP_TYPES } from "../../view/popup/PopupContainer";
import ActionTooltip from "../../view/ActionTooltip";
import { Download } from "lucide-react";
// import { getFilters } from "../../view/urlService";



function ValidateTableHeader({ whitelisted, validationResultList, currentUser, userCapability }) {

    const history = useHistory();

    const { config, setConfig } = useContext(TableContext);
    const [showModal, setShowModal] = useState(false);
    const selectedCount = config.selected?.length || 0;
    const isRemediateActive = selectedCount === 1;
    const [lastValidation, setLastValidation] = useState('N/A');
    const [lastRunTimestamp, setLastRunTimestamp] = useState(null);
    const [btnWhitelistName, setBtnWhitelistName] = useState('View Whitelist');
    const { setPopup } = useContext(PopupContext);

    //#region Set User Capabilities
    const [remediateCapability, setRemediateCapability] = useState(-1);
    const [clearwhitelistCapability, setClearwhitelistCapability] = useState(-1);
    const [acknowledgeCapability, setAcknowledgeCapability] = useState(-1);
    const [exportdataCapability, setExportdataCapability] = useState(-1);
    useEffect(() => {
        if (userCapability) {
            const remediatePermission = userCapability.find(item =>
                item.component === "validationremediate" && item.type === "field")?.permission;
            setRemediateCapability(remediatePermission);
            const clearWhitelistPermission = userCapability.find(item =>
                item.component === "validationclearwhitelist" && item.type === "field")?.permission;
            setClearwhitelistCapability(clearWhitelistPermission);
            const acknowledgePermission = userCapability.find(item =>
                item.component === "validationacknowledge" && item.type === "field")?.permission;
            setAcknowledgeCapability(acknowledgePermission);
            const exportDataPermission = userCapability.find(item =>
                item.component === "validationexportdata" && item.type === "field")?.permission;
            setExportdataCapability(exportDataPermission);
        }
        /* eslint-disable react-hooks/exhaustive-deps */
    }, []);
    //#endregion

    // const getLastValidationTime = async () => {
    //     const response = await getLastAnalysisDateTime();        
    //     let time = 'N/A';
    //     if (response && typeof response === "number") {
    //         //alert(12);            
    //         const dateObject = new Date(response);
    //         time = dateObject.toLocaleString();
    //         //time = moment(response).local().format('YYYY-MM-DD HH:MM:SS');
    //         if (lastRunTimestamp && lastRunTimestamp !== response) {
    //             //alert(13);
    //             setLastRunTimestamp(lastRunTimestamp);
    //             setConfig({...config, lastUpdated: Date.now()});
    //         }
    //     }
    //     if (lastValidation !== time) {
    //         //alert(14);
    //         setLastValidation(time);
    //         setConfig({...config, lastUpdated: Date.now()});
    //     }
    // }

    const acknowledgeBtnDisabled = () => {
        const { msbId, deviceId } = config;

        if (!msbId || !deviceId) {
            return true;
        }

        if (config.selected.length === 0) {
            return true;
        }

        if (btnWhitelistName === 'Clear Whitelist') {
            return true;
        }

        return Number(msbId) < 0 || Number(deviceId) < 0;
    }

    // useEffect(() => {
    //     onAcknowledgeClick();
    //     /* eslint-disable react-hooks/exhaustive-deps */
    // }, [selectedDate]);

    // const DatePickerInput = forwardRef(({ value, onClick }, ref) => (
    //     // <button className="btn oct_btn-form" onClick={onClick} ref={ref}>
    //     //     {value}
    //     // </button>


    //             <div className={`oct_card-btn btn oct_btn-secondary ${(acknowledgeBtnDisabled() || acknowledgeCapability === 0) && 'disabled'}`} 
    //                 onClick={acknowledgeBtnDisabled() ? null : onClick} ref={ref}>            
    //                 Acknowledge
    //             </div>


    // ));


    const onAcknowledgeClick = async () => {
        if (!config.selected || !config.selected.length || acknowledgeBtnDisabled()) {
            return; //showWarningToast('No selected rows found', 'Acknowledge');
        }
        onAddAcknowledgeExpiryDate();
    }

    const onAddAcknowledgeExpiryDate = () => setPopup(
        {
            type: POPUP_TYPES.ADD_ACKNOWLEDGE_EXPIRY_DATE,
            selectedDate: new Date(),
            comment: "",
            confirm: confirmAcknowledgeCreation
        }
    );

    const confirmAcknowledgeCreation = async (selectedDate, comment) => {
        if (!config.selected || !config.selected.length) {
            return; //showWarningToast('No selected rows found', 'Acknowledge');
        }
        let expiryDate;
        if (selectedDate) {
            const endOfDay = new Date(selectedDate);
            endOfDay.setHours(23, 59, 59, 999); // Set time to 11:59:59.999
            expiryDate = Math.floor(endOfDay.getTime());
        } else {
            expiryDate = null;
        }

        await acknowledgeValidationResult(config.selected, expiryDate, comment, 0)
            .then(() => showSuccessToast('Validation result was added to the whitelist', 'Acknowledge'))
            .then(() => setConfig({ ...config, lastUpdated: Date.now() }))
    };



    const whitelistedLength = () => {
        if (btnWhitelistName === 'View Whitelist') {
            return whitelisted;
        }
        else if (btnWhitelistName === 'Clear Whitelist') {
            return config.selected.length;
        }
        return 0;
    }

    const onWhitelistClick = async () => {
        if (whitelistedLength() === 0) {
            return;
        }
        if (btnWhitelistName === 'View Whitelist') {
            setBtnWhitelistName('Clear Whitelist');
            history.push({
                pathname: history.pathname,
                search: urlService.updateFilters('whitelist', true)
            })
        }
        else if (btnWhitelistName === 'Clear Whitelist') {
            const selected = config.selected;
            if (selected.length > 0) {
                //const { msbId, deviceId } = config;
                await removeRulesFromWhitelist(selected, 0)
                    .then(response => response && showSuccessToast('Validation selected whitelist cleared', 'Clear Whitelist'))
                    .then(() => setConfig({ ...config, lastUpdated: Date.now() }))
            }
        }
    }

    const onViewValidationResultClick = async () => {
        setBtnWhitelistName('View Whitelist');
        history.push({
            pathname: history.pathname,
            search: urlService.removeFilter('whitelist')
        })
    }

    // const onClearWhitelistClick = async () => {
    //     const { msbId, deviceId } = config;
    //     await removeFromWhitelist({ msbId, deviceId }, 0)
    //         .then(response => response && showSuccessToast('Validation whitelist cleared', 'Clear Whitelist'))
    //         .then(() => setConfig({ ...config, lastUpdated: Date.now() }))
    // }



    const showRemediate = () => {
        const validationResult = validationResultList.find(vr => vr.id === config?.selected[0]);
        if (validationResult) {
            return <RemediationModal ruleId={validationResult.rulePk}
                deviceId={validationResult.devicePk}
                realTime={0}
                resultId={validationResult.id}
                validationResult={validationResult}
                closeModal={() => setShowModal(false)}
                currentUser={currentUser}
                disabled={remediateCapability === 0 ? true : false} />
        } else {
            return null;
        }
    }

    //Added by Octopus DevTeam july 6 2022
    const exportData = () => {
        exportValidationData();
    }

    const remediateTooltip = selectedCount === 2
        ? 'You cannot remediate more than one rule at a time.'
        : '';

    useEffect(() => {
        getLastValidationTime();
    }, [validationResultList.length])

    //useInterval(() => getLastValidationTime(), 3500);

    const getLastValidationTime = async () => {
        let time = 'N/A';
        //setLastValidation(time);
        if (validationResultList.length <= 0) {
            setLastValidation(time);
            return;
        }
        //const selectedDeviceId = validationResultList[0].devicePk;
        const response = await getLastValidationDateTime();

        if (response && typeof response === "number") {
            //alert(12);            
            const dateObject = new Date(response);
            time = dateObject.toLocaleString();
            //time = moment(response).local().format('YYYY-MM-DD HH:MM:SS');
            if (lastRunTimestamp && lastRunTimestamp !== response) {
                //alert(13);
                setLastRunTimestamp(lastRunTimestamp);
                //setConfig({ ...config, lastUpdated: Date.now() });
            }
        }
        if (lastValidation !== time) {
            //alert(14);
            setLastValidation(time);
            //setConfig({ ...config, lastUpdated: Date.now() });
        }
    }

    return (
        <>
            {showModal && showRemediate()}
            <div className="oct_analysis-header-v2 mb-4">
                <div className="oct_analysis-title-section">
                    <h2>CONFIGURATION DIFFERENCES</h2>
                    <div className="oct_last-analysis" data-toggle="tooltip"
                        title="Last Analysis date">Last validation: {lastValidation}</div>
                </div>

                <div className="oct_analysis-actions">
                    {btnWhitelistName === 'Clear Whitelist' &&
                        <button
                            onClick={() => onViewValidationResultClick()}
                            className="oct_btn-outline-v2">
                            View Results
                        </button>
                    }

                    <ActionTooltip
                        title={!isRemediateActive ? remediateTooltip : ""}
                        placement="top">
                        <button
                            onClick={() => setShowModal(true)}
                            className="oct_btn-outline-v2"
                            disabled={!isRemediateActive}
                            style={!isRemediateActive ? { pointerEvents: 'none' } : undefined}>
                            Remediate
                        </button>
                    </ActionTooltip>

                    <button
                        onClick={clearwhitelistCapability === 0 ? null : () => onWhitelistClick()}
                        className="oct_btn-outline-v2"
                        disabled={!whitelistedLength() || clearwhitelistCapability === 0}>
                        <span>{btnWhitelistName}</span>
                        {whitelistedLength() ? <span className="ml-1">({whitelistedLength()})</span> : null}
                    </button>

                    <button
                        onClick={acknowledgeCapability === 0 ? null : () => onAcknowledgeClick()}
                        className="oct_btn-outline-v2"
                        disabled={acknowledgeBtnDisabled() || acknowledgeCapability === 0}>
                        Acknowledge
                    </button>

                    <button
                        onClick={exportdataCapability === 0 ? null : exportData}
                        className="oct_btn-export-v2"
                        disabled={exportdataCapability === 0}>
                        <Download className="oct_icon" />
                        Export Data
                    </button>
                </div>
            </div>
            {/*
            <div className="mr-4 mb-4 mt-4">
                <SearchInputV2
                    value={searchTerm}
                    onChange={(e) => {
                        const value = e.target.value;
                        setSearchTerm(value);
                        setConfig({ ...config, searchTerm: value });
                    }}
                    placeholder="Search by rule name, description, or severity..."
                />
            </div>
            */}
            {/* <div className="ml-4 mb-4">
                <ValidationResultTableSearchSection/>
            </div> */}
        </>
    );
}

function mapStateToProps(state) {
    debug("ValidateTableHeader mapStateToProps", state);
    const auth = state.auth;
    const validatePage = state.validatePage;
    const metadata = validatePage.metadata || {};
    const validationResultList = validatePage.validationResultList || [];
    return {
        whitelisted: metadata.whitelisted || 0,
        validationResultList,
        currentUser: auth.firstName + ' ' + auth.lastName,
        userCapability: auth.userCapability
    }
}

export default connect(mapStateToProps)(ValidateTableHeader);
